import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.4y3rEL',
    defaultMessage: 'Snapshots',
  },
});
